import React from 'react';

import Input from './Input';


const validateLimit = (rule, value, callback) => {
  if (value) {
    callback();
  } else {
    callback();
  }
}

const rule = [

  {
    pattern: new RegExp(/^[0-9]*[0-9][0-9]*$/),
    message: '请输入一个正整数',
  },
  {
    pattern: new RegExp(/^.{0,11}$/),
    message: '数值超出预期',
  },
];

const rule2 = [

  {
    pattern: new RegExp(/^[0-9]*[0-9][0-9]*$/),
    message: '请输入一个正整数',
  },
  {
    required: true,
    message: '此项不能为空',
  },
  {
    pattern: new RegExp(/^.{0,11}$/),
    message: '数值超出预期',
  },
];

const InputInt = (props) => (
  <Input {...props} disabled={props.actionDisable} rules={props.noNull ? rule2 : rule} ></Input>
);

export default InputInt;